import React, { useState } from "react";
import styled from "styled-components";
import megaphone from "../assets/megaphone.png";
import chat from "../assets/chat.png";
import headphones from "../assets/headphones.png";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import DashFooter from "./DashFooter";
import DashboardSidebar from "./DashboardSidebar";

const ManageAccount = () => {
  const [toggleTab, setToogleTab] = useState(1);
  const tooggleBtn = (index) => {
    setToogleTab(index);
  };

  const [showPassword, setShowPassword] = useState(false);
  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <DashboardSidebar>
        <AccountMain>
          <h3>Manage Account</h3>
          <BillingToggle>
            <li onClick={() => tooggleBtn(1)}>
              {toggleTab === 1 ? <div className="borderActive"></div> : null}
              <span className={toggleTab === 1 ? "colorActive" : "color"}>
                Overview
              </span>
            </li>
            <li onClick={() => tooggleBtn(2)}>
              {toggleTab === 2 ? <div className="borderProfile"></div> : null}
              <span className={toggleTab === 2 ? "colorActive" : "color"}>
                Profile Info
              </span>
            </li>
            <li onClick={() => tooggleBtn(3)}>
              {toggleTab === 3 ? <div className="borderReset"></div> : null}
              <span className={toggleTab === 3 ? "colorActive" : "color"}>
                Reset Password
              </span>
            </li>
          </BillingToggle>
          <Border></Border>
          {toggleTab === 1 ? (
            <Overview>
              <OverviewGrid>
                <OverviewCard>
                  <h4>GET HELP</h4>
                  <div>
                    <img src={headphones} alt="" />
                    <div className="doc">
                      <p>
                        View active support cases and speak to the Support team
                      </p>
                      <div className="visit">Visit Support</div>
                    </div>
                  </div>
                </OverviewCard>
                <OverviewCard>
                  <h4>CONNECT & DISCUSS</h4>
                  <div>
                    <img src={chat} alt="" />
                    <div className="doc">
                      <p>
                        Meet and seek guidance from other MongoDB developers
                      </p>
                      <div className="visit">Visit Community</div>
                    </div>
                  </div>
                </OverviewCard>
                <OverviewCard>
                  <h4>LEAVE FEEDBACK</h4>
                  <div>
                    <img src={megaphone} alt="" />
                    <div className="doc">
                      <p>
                        Share your ideas to help improve our product and
                        services
                      </p>
                      <div className="visit">Leave Feedback</div>
                    </div>
                  </div>
                </OverviewCard>
              </OverviewGrid>
            </Overview>
          ) : null}
          {toggleTab === 2 ? (
            <>
              <AccountCard>
                <div className="grid">
                  <div>
                    <label>Full Name*</label>
                    <input type="text" name="" id="" />
                  </div>
                  <div>
                    <label>Company Name (Optional)</label>
                    <input type="text" name="" id="" />
                  </div>
                </div>
                <div className="grid">
                  <div>
                    <label>Email Id*</label>
                    <input type="email" name="" id="" />
                  </div>
                  <div>
                    <label>Mobile No*</label>
                    <input type="number" name="" id="" />
                  </div>
                </div>
                <div className="grid"></div>
                <div>
                  <label>Address*</label>
                  <textarea cols="30" rows="3"></textarea>
                </div>
                <Save>Save Changes</Save>
              </AccountCard>
              {/* <DeleteCard>
              <h4>Delete Account</h4>
              <p>
                You will lose access to your Money Manager account once your
                deletion request has been submitted.
              </p>
              <div className="delete">Delete Account</div>
            </DeleteCard> */}
            </>
          ) : null}
          {toggleTab === 3 ? (
            <PassCard>
              <PassContainer>
                <label>Password*</label>
                <input type={showPassword ? "text" : "password"} required />
                <div className="icon" onClick={togglePassword}>
                  {showPassword ? (
                    <AiOutlineEyeInvisible size={20} />
                  ) : (
                    <AiOutlineEye size={20} />
                  )}
                </div>
              </PassContainer>
              <PassContainer>
                <label>Confirm Password*</label>
                <input type={showPassword ? "text" : "password"} required />
                <div className="icon" onClick={togglePassword}>
                  {showPassword ? (
                    <AiOutlineEyeInvisible size={20} />
                  ) : (
                    <AiOutlineEye size={20} />
                  )}
                </div>
              </PassContainer>
              <SaveBtn>Save Changes</SaveBtn>
            </PassCard>
          ) : null}
        </AccountMain>
        <DashFooter />
      </DashboardSidebar>
    </>
  );
};

export default ManageAccount;

const AccountMain = styled.div`
  h3 {
    font-weight: 500;
    font-size: 35px;
    font-family: "Source Serif Pro", serif;
    color: rgb(0, 104, 74);
  }
`;

const BillingToggle = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  li {
    cursor: pointer;
    position: relative;
    list-style: none;
    margin-right: 25px;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 17px;
      text-align: center;
      margin-left: 18px;
    }
    margin-top: 20px;
  }

  .colorActive {
    color: rgb(28, 45, 56);
  }
  .color {
    color: #c1c7c6;
  }

  .borderActive {
    position: absolute;
    top: 120%;
    left: 1%;
    background-color: rgb(28, 45, 56);
    height: 3px;
    width: 110px;
  }
  .borderProfile {
    position: absolute;
    top: 120%;
    left: 2%;
    background-color: rgb(28, 45, 56);
    height: 3px;
    width: 120px;
  }
  .borderReset {
    position: absolute;
    top: 120%;
    left: 1%;
    background-color: rgb(28, 45, 56);
    height: 3px;
    width: 170px;
  }

  @media only screen and (max-width: 991px) {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    li {
      span {
        text-align: center;
        margin-left: 0px;
      }
    }
    .borderActive {
      position: absolute;
      top: 120%;
      left: 0%;
      background-color: rgb(28, 45, 56);
      height: 3px;
      width: 100%;
    }
  }
`;

const Border = styled.div`
  background-color: #cfcece;
  height: 3px;
  margin-top: 5px;
  width: 100%;
`;

const Overview = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 15px;
`;

const OverviewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`;

const OverviewCard = styled.div`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #cfcfcf;
  background-color: #fff;
  padding: 10px 0px;
  border-radius: 7px;

  h4 {
    color: rgb(0, 104, 74);
    font-weight: 500;
    font-size: 13px;
    margin-left: 15px;
  }
  div {
    display: flex;
    padding: 10px;
    position: relative;
    img {
      position: absolute;
      top: 23%;
      width: 50px;
      height: 50px;
      margin-right: 15px;
      margin-left: 15px;
    }
    .doc {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      margin-left: 4.8rem;
    }
    .visit {
      padding: 2px 10px;
      border: 2px solid rgb(0, 104, 74);
      border-radius: 8px;
      font-size: 13px;
      font-weight: 500;
      margin-top: 10px;
      color: rgb(0, 104, 74);
      cursor: pointer;
    }
    p {
      font-weight: 400;
      color: rgb(0, 104, 74);
      font-size: 15px;
    }
  }
`;

const AccountCard = styled.form`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #cfcfcf;
  margin-top: 15px;
  padding: 0px;
  border-radius: 8px;
  width: 70%;
  padding: 20px 20px;

  .block {
    display: block;
  }
  .none {
    display: none;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    margin-bottom: 0.5rem;
  }
  div {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;

    label {
      font-weight: 500;
      font-size: 15px;
      color: rgb(0, 104, 74);
      margin-bottom: 3px;
    }
    input {
      width: 100%;
      border: none;
      outline: none;
      padding: 8px 10px;
      border: 2px solid #3aaa35;
      border-radius: 6px;
      font-size: 15px;
      font-weight: 500;
      color: rgb(0, 30, 43);
    }
    textarea {
      width: 100%;
      border: none;
      outline: none;
      padding: 8px 10px;
      border: 2px solid #3aaa35;
      border-radius: 6px;
      font-size: 15px;
      font-weight: 500;
      color: rgb(0, 30, 43);
    }
  }
  @media only screen and (max-width: 991px) {
    width: 100%;
    .grid {
      grid-template-columns: 1fr;
    }
  }
`;

const DeleteCard = styled.div`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #cfcfcf;
  margin-top: 15px;
  padding: 0px;
  border-radius: 8px;
  width: 47%;
  padding: 20px 20px;
  margin-bottom: 2rem;
  h4 {
    font-weight: 500;
    font-size: 18px;
    color: rgb(0, 30, 43);
  }
  p {
    font-weight: 400;
    font-size: 16px;
    color: rgb(0, 104, 74);
  }
  .delete {
    padding: 10px 15px;
    background-color: #ff3737;
    border-radius: 8px;
    color: #fff;
    font-weight: 500;
    font-size: 15px;
    width: 35%;
    text-align: center;
    margin-top: 0.7rem;
    cursor: pointer;
  }
`;

const Save = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 9px 15px;
  background-color: #3aaa35;
  border-radius: 8px;
  color: #fff;
  width: 25%;
  cursor: pointer;
  margin-top: 1rem;
  font-weight: 500;

  @media only screen and (max-width: 991px) {
    width: 50%;
  }
`;

const SaveBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 9px 15px;
  background-color: #3aaa35;
  border-radius: 8px;
  color: #fff;
  width: 25%;
  cursor: pointer;
  margin-top: 1rem;
  font-weight: 500;

  @media only screen and (max-width: 991px) {
    width: 50%;
  }
`;

const PassCard = styled.div`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #cfcfcf;
  margin-top: 15px;
  padding: 0px;
  border-radius: 8px;
  width: 60%;
  padding: 20px 20px;
  margin-bottom: 4rem;

  @media only screen and (max-width: 991px) {
    width: 100%;
  }
`;

const PassContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 15px;

  input {
    width: 100%;
    border: none;
    outline: none;
    border: 2px solid #3aaa35;
    padding: 7px 10px;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 500;
    color: #20204f;
  }
  label {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 5px;
    color: #20204f;
  }
  .icon {
    position: absolute;
    top: 2.35rem;
    right: 1rem;
    cursor: pointer;
  }
  @media only screen and (max-width: 991px) {
    /* align-items: center; */
    input {
      width: 100%;
    }
  }
`;
